module.exports = __webpack_public_path__ + "img/costco.603ab028.png";